import { safeJsonParse } from '@utils/safeJsonParse'

export function getBooleanFromValue(value: string | boolean) {
  return typeof value === 'boolean' ? value : Boolean(safeJsonParse(value))
}
